import React, { useEffect } from "react";
import { useLocation } from "react-router";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";

import { FullScreenProvider, useFullScreen } from "../../contexts/fullScreen";
import ChargesSummaryModals from "../ShoppingLayout/ChargesSummaryModals/ChargesSummaryModals";
import SideBar from "./SideBar/index";

const background = "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)";

const ProjectLayout = ({ children }) => {
  const location = useLocation();
  const { fullScreen, setFullScreen } = useFullScreen();

  useEffect(() => {
    setFullScreen(false);
  }, [location.pathname]);

  const styles = {
    root: {
      background,
      display: "flex",
      height: "100%",
      overflow: "hidden",
      width: "100%",
    },
    wrapper: {
      display: "flex",
      flex: "1 1 auto",
      overflow: "hidden",
      paddingTop: fullScreen ? 0 : "64px",
    },
    container: {
      display: "flex",
      flex: "1 1 auto",
      overflow: "hidden",
      position: "relative",
      background,
    },
    content: {
      flex: "1 1 auto",
      height: "100%",
      overflow: "auto",
    },
  };

  return (
    <Box sx={styles.root}>
      <CssBaseline />

      {!fullScreen && <SideBar />}

      <Box sx={styles.wrapper}>
        <Box sx={styles.container}>
          <Box id="content" sx={styles.content}>
            {children}
            <ChargesSummaryModals />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default props => (
  <FullScreenProvider>
    <ProjectLayout {...props} />
  </FullScreenProvider>
);
